module.exports = __webpack_public_path__ + "static/media/games_tournament_t.212881cc.png";